import React from 'react';
import styled from 'styled-components';
import { Info } from '@zocdoc-frontend-common/assets-icons';
import {
    Tooltip as BaseTooltip,
    TOOLTIP,
} from '@zocdoc-frontend-common/components-tooltip';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { grey } from '@zocdoc/branding/colors';

export default function Tooltip(props) {
    const { children, onViewTooltip, shouldShrinkWidth = false } = props;
    return (
        <div style={{ display: 'inline-block', marginLeft: 6 }}>
            <StyledTooltip
                alt={children}
                anchor={<StyledInfo color={grey} />}
                showTooltipOnFocus
                showTooltipOnHover
                tooltipPosition={TOOLTIP.TOP}
                onViewTooltip={onViewTooltip}
                shouldShrinkWidth={shouldShrinkWidth}
            >
                {children}
            </StyledTooltip>
        </div>
    );
}

const StyledInfo = styled(Info)`
    font-size: 12px;
`;

const StyledTooltip = styled(BaseTooltip)`
    ${breakpoint.small} {
        left: 50%;
        transform: translateX(-50%);
        width: 240px;
    }
    ${breakpoint.medium} {
        width: ${(p) => (p.shouldShrinkWidth ? '200px' : '280px')};
    }
`;
